// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__4TTM5","label":"Completed_label__3Cncx"};